import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../../../constants/constants';

export const componentKey = "MANAGE_FORMS/BULK_STATE_FILING";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setSelectedForm: (state, action) => {
            state.selectedForm = action.payload;
        },
        setBulkStateAmount: (state, action) => {
            state.bulkStateAmount = action.payload;
        },
        setPaymentDrawerModal: (state, action) => {
            state.paymentDrawerModal = action.payload;
        },
        setFormSelectionModal: (state, action) => {
            state.formSelectionModal = action.payload;
        },
        setReferenceList: (state, action) => {
            state.referenceList = action.payload;
        },
    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },
        selectedForm: { label: "", value: "" },
        bulkStateAmount: {},
        referenceList: [],
        // Modals
        formSelectionModal: true,
        paymentDrawerModal: false,
    }
})

export const { setLoadingState, setSelectedForm, setBulkStateAmount, setPaymentDrawerModal, setFormSelectionModal, setReferenceList } = actions; 
